import $http from '@/libs/axios'

export default class VcardsApi {
  /**
   * Create business card (handles registration/login and vcard creation)
   */
  static async createBusinessCard(data: {
    pageId?: number | string;
    accountId?: number | string;
    isInstagram?: boolean;
    url_alias: string;
    name: string;
    group_id?: number;
    template_id?: number;
  }) {
    // Call our backend API which will handle the vcards integration
    return (await $http.post('vcards/create-business-card', data)).data
  }

  /**
   * Delete business card (remove vcard association)
   */
  static async deleteBusinessCard(data: {
    pageId?: number | string;
    accountId?: number | string;
    isInstagram?: boolean;
  }) {
    return (await $http.delete('vcards/delete-business-card', { data })).data
  }

  /**
   * Get templates list from vcards
   */
  static async getTemplates() {
    return (await $http.get('vcards/templates')).data
  }
}
